export default __webpack_public_path__ + "static/media/bg_big_red_big.32ca9802.svg";